import { Link } from "react-router-dom";
import useAuth from "context/useAuth";

const AboutPage = () => {
  const { user, loading } = useAuth();

  return (
    <>
      <section className="top_matches pb-8 pb-md-10">
        <style>
          {`
                        .top_matches__main p, .top_matches__main h3 {
                            margin-bottom: 1.5rem; /* Adjust the value as needed for more spacing */
                        }
                        p, h3, hr {
                            //line-height: 1.6; /* Adjust line height for better readability */
                            // font-size: 1.1rem; /* Adjust font size for better readability */
                            color: #333; /* Darker text for better contrast */
                        }
                    `}
        </style>
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-8 gx-0 gx-sm-4">
              <div className="top_matches__main pt-20">
                <span className="d-block mb-3 text-primary">
                  This page is under development
                </span>
                <h3>What is IntPulse.io and how does it work?</h3>
                <p>
                  <b>IntPulse.io</b> is a prediction market platform where users
                  forecast real-world financial outcomes, such as the direction
                  of stocks, currencies, or global economic events. You
                  participate by selecting an outcome, placing a stake on it,
                  and receiving a payout if your prediction is correct.
                </p>
                <p>
                  We manage the underlying risk using real market strategies and
                  financial instruments. This allows us to ensure that every
                  winning prediction is paid out reliably and fairly. It’s a
                  simple and transparent way to turn your insight into reward.
                </p>
                <Link to="/market">
                  <button className="cmn-btn px-xxl-11 rounded-2 mt-3 mb-4 me-2">
                    View Markets
                  </button>
                </Link>
                {!user && !loading && (
                  <Link to="/register">
                    <button className="cmn-btn px-xxl-11 rounded-2 mt-3 mb-4">
                      Sign Up
                    </button>
                  </Link>
                )}
                {user && !loading && (
                  <Link to="/account">
                    <button className="cmn-btn px-xxl-11 rounded-2 mt-3 mb-4">
                      My Account
                    </button>
                  </Link>
                )}
                <img
                  className="w-100"
                  src="/assets/images/prediction-guide-1.png"
                  alt="About IntPulse.io"
                />
                <hr />
                <h3>Our Mission</h3>
                <p>
                  At <b>IntPulse.io</b>, our mission is to make market
                  participation more accessible, exciting, and rewarding. We aim
                  to open the doors of financial forecasting to everyone, not
                  just seasoned traders or insiders. By transforming complex
                  market events into straightforward prediction opportunities,
                  we bring the thrill of market movements to a wider audience,
                  while helping users learn, engage, and potentially profit
                  through clear, understandable mechanisms.
                </p>

                <hr />
                <h3>Our Vision</h3>
                <p>
                  We envision a{" "}
                  <b>fairer and more transparent financial system</b>, one that
                  removes the built-in advantages long held by large
                  institutions. Traditional markets often rely on hidden fees,
                  complex instruments, and barriers that make tools like
                  short-selling difficult or inaccessible to most. At{" "}
                  <b>IntPulse.io</b>, we believe in breaking down those
                  structures, offering an alternative where outcomes are traded
                  in open, unbiased ways, and where understanding drives
                  participation.
                </p>

                <hr />
                <h3>What We Stand For</h3>
                <p>
                  <b>We believe in creating opportunity.</b> Our platform is
                  designed to empower individuals to take part in forecasting
                  financial events, from stock movements to currency shifts, in
                  a way that is both simple and meaningful.
                </p>

                <p>
                  <b>We stand for clarity.</b> Users should never feel lost in
                  jargon or overwhelmed by technical interfaces. We strive to
                  deliver a market that is easy to navigate, easy to understand,
                  and rewarding to use.
                </p>

                <p>
                  <b>We challenge the status quo.</b> Financial systems should
                  not tilt in favor of those with structural advantages. By
                  rethinking how people engage with markets, we aim to build a
                  system where everyone plays by the same rules and the best
                  insight wins.
                </p>

                <hr />
                <h3>How We Ensure You Get Paid</h3>
                <p>
                  When you win a prediction on <b>IntPulse.io</b>, your payout
                  is secured. We work with experienced traders and use complex
                  financial instruments to manage risk and guarantee that
                  winnings are fully covered.
                </p>
                <p>
                  In simple terms, we hedge your prediction in the real market,
                  like buying insurance to make sure your reward is there if you
                  are right. This system allows us to honor payouts smoothly and
                  reliably, no matter the outcome.
                </p>
                <p>
                  Your accuracy drives the result, and we make sure you are paid
                  for it.
                </p>

                <hr />
                <h3>How is this different from trading or gambling?</h3>
                <p>
                  <b>IntPulse.io</b> is not trading, and it is not gambling. It
                  is a new way to engage with markets through forecasting.
                </p>
                <p>
                  With <b>IntPulse.io</b>, you are not buying or selling assets.
                  You are making a call on a specific outcome and staking your
                  confidence in it. Unlike gambling, outcomes are tied to real
                  market events, rather than luck.
                </p>
                <p>
                  We aim to create a level playing field where rewards are based
                  on informed decisions, not complicated systems or random
                  chance.
                </p>

                <hr />
                <h3>How are market outcomes verified?</h3>
                <p>
                  Each prediction market on <b>IntPulse.io</b> is tied to a
                  real, publicly verifiable event, such as a stock closing
                  price, a forex rate, or a crypto price. Once the event
                  concludes, we use trusted third-party data sources like
                  financial APIs, official exchanges, or newswire services to
                  determine the correct outcome.
                </p>
                <p>
                  Most predictions related to stocks, forex, or crypto prices
                  include a short verification window, where the final result is
                  based on the <b>average price during a fixed time period</b>,
                  often 30 minutes after the event’s closing time. This helps
                  avoid price manipulation, random spikes, or illiquid data
                  points, and ensures fairer outcomes for all participants.
                </p>
                <p>
                  Our resolution process is transparent and rule-based. Every
                  market includes clear criteria from the start, so there’s no
                  ambiguity. In rare cases where data is delayed or disputed, we
                  pause resolution until the outcome can be confirmed by
                  reliable sources.
                </p>
                <p>
                  Our goal is to settle every market fairly, using data you can
                  trust.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer id="footer"></footer>
    </>
  );
};

export default AboutPage;
